module.exports = __webpack_public_path__ + "static/media/S2N11-1.f8af410f.svg";